export enum LOGIN_STORAGE_KEYS {
  UserIdPreference = "user-id-preference"
}
